// extracted by mini-css-extract-plugin
module.exports = {"wishlistIconButton":"V5ATN","iconContainer":"_3Yyxl","heartIcon":"_1vD2j","filled":"_1nQx0","empty":"_2_JeV","floatingMode":"_2OYPi"};